import firebase from 'firebase'
import { db } from '../../../config/firebaseconfig'
const uuid = require('uuid/v1')

export default function addSet(setName) {
  const id = uuid()
  return new Promise((resolve, reject) => {
    db.collection('sets').doc(id).set({
      id,
      name: setName,
      contentType: 'Set',
    })
      .then(() => resolve(id))
      .catch( (error) => reject(error))
  })
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/addSet.js